import styles from './style.css'
import { connect } from 'react-redux'

class SuccessForgotPassword extends React.Component {
  render () {
    let {forgotState} = this.props.data.moka
    let {email} = forgotState
    return (
      <div className='container'>
        <div className='row'>
          <div className='col-sm-6 col-sm-offset-3'>
            <div className={styles['success-forgot-password']}>
              <h1 className='text-center'>Instructions have been sent</h1>
              <hr />
              <div className='text-center'>
                <img alt='Email logo' src={require('../../assets/images/email_logo.png')} />
                <br />
                Password reset instruction has been sent to <span className={styles['text-email']}>{email}</span>.
                <br />
                <br />
                Don&#39;t forget to check your spam and junk filters if they don&#39;t arrive.
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function select (state) {
  return {
    data: state
  }
}

export default connect(select)(SuccessForgotPassword)



// WEBPACK FOOTER //
// ./app/pages/SuccessForgotPassword/SuccessForgotPassword.js